import { validateEmail, validateName, validatePassword } from '@/lib/validate';
import * as yup from 'yup';

export interface SignupFormValues {
  name: string;
  email: string;
  password: string;
}

/** Yup schema mirroring {@link validateName}, {@link validateEmail}, {@link validatePassword}. */
export function createSignupSchema(t: (key: string) => string) {
  return yup.object({
    name: yup
      .string()
      .required(() => t('signup_required_name'))
      .test('name', function (value) {
        const result = validateName(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
    email: yup
      .string()
      .required(() => t('signup_required_email'))
      .test('email', function (value) {
        const result = validateEmail(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
    password: yup
      .string()
      .required(() => t('signup_required_password'))
      .test('password', function (value) {
        const result = validatePassword(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
  });
}
